import React, { useEffect, useState } from "react";
import axios, { MEDIA_BASE_URL } from "../../axios/axios";
import Layout from "./Layout";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { ToastContainer, toast } from "react-toastify";

const UploadBanner = () => {
  const [file, setFile] = useState(null);
  const [banners, setBanners] = useState([]);

  const fetchBanners = async () => {
    try {
      const response = await axios.get("/banner/");
      setBanners(response.data);
    } catch (error) {
      console.error("Error fetching banners", error);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) return alert("Please select a file");

    const formData = new FormData();
    formData.append("banner", file);

    try {
      const res = await axios.post("/banner/", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Banner uploaded successfully!");
      setFile(null);
      fetchBanners(); // refresh banner list
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Failed to upload banner");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this banner?")) return;

    try {
      await axios.delete(`/banner/${id}`);
      toast.success("Banner deleted successfully!");
      fetchBanners(); // refresh list
    } catch (error) {
      console.error("Failed to delete banner:", error);
      alert("Failed to delete banner");
    }
  };

  return (
    <>
      <Navbar />
      <Layout>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="container mt-4">
          <h3 className="fw-bold">Upload Banner</h3>
          <form onSubmit={handleSubmit} className="w-50 ">
            <input
              type="file"
              className="form-control shadow-none my-4"
              accept="image/*"
              onChange={handleFileChange}
            />
            <small className="text-muted d-block">
              Recommended image size: 1920 × 600px (landscape, ~3.2:1 ratio).
              The banner is shown edge-to-edge and cropped to fit, so images
              smaller or with a very different ratio may look off on some
              screens.
            </small>
            <button type="submit" className="btn btn-primary mt-3">
              Upload Banner
            </button>
          </form>

          <div className="mt-5">
            {banners.map((banner) => (
              <div
                key={banner._id}
                className="mb-4 d-flex align-items-center gap-3"
              >
                <img
                  src={`${MEDIA_BASE_URL}/${banner.imageUrl}`}
                  alt="banner"
                  width={250}
                  height={150}
                  crossOrigin="anonymous"
                  style={{ borderRadius: "8px" }}
                />
                <button
                  className="btn btn-danger"
                  onClick={() => handleDelete(banner._id)}
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
      </Layout>
      <Footer />
    </>
  );
};

export default UploadBanner;
